import { css } from "@emotion/react";

export const fileInputCss = css`
  display: flex;
  align-items: center;
`;

export const hideInputCss = css`
  display: none;
`;

export const uploadButtonCss = css`
  background-color: #2e5e96;
  color: white;
  border-radius: 50%;
  height: 35px;
  width: 35px !important;
  min-width: 35px;
  box-shadow: 0px 3px 5px -1px rgb(0 0 0 / 20%),
    0px 6px 10px 0px rgb(0 0 0 / 14%), 0px 1px 18px 0px rgb(0 0 0 / 12%);
  &:hover {
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    background-color: white;
    color: #2e5e96;
    box-shadow: inset 0px 0px 0px 1px #2e5e96;
  }
`;
export const uploadButtonDisabledCss = css`
  background-color: rgba(0, 0, 0, 0.12);
  color: rgba(0, 0, 0, 0.26);
  box-shadow: none;
  margin-left: 8px;
  border-radius: 50%;
  height: 35px;
  width: 35px !important;
  min-width: 35px;
  &:hover {
    background-color: rgba(0, 0, 0, 0.12);
    color: rgba(0, 0, 0, 0.26);
    box-shadow: none;
    cursor: initial;
  }
`;
